// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__rUlkL","container":"MainLayout_container__UzRQd","content":"MainLayout_content__7fz-U"};